var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2271 42.3729V19.0896C19.2271 18.1729 19.502 17.2792 20.0062 16.5229L26.2625 7.21874C27.2479 5.72916 29.7 4.67499 31.7854 5.45416C34.0312 6.21041 35.5208 8.73124 35.0395 10.9771L33.8479 18.4708C33.7562 19.1583 33.9395 19.7771 34.3291 20.2583C34.7187 20.6937 35.2916 20.9687 35.9104 20.9687H45.3291C47.1395 20.9687 48.6979 21.7021 49.6145 22.9854C50.4854 24.2229 50.6458 25.8271 50.0729 27.4542L44.4354 44.6187C43.725 47.4604 40.6312 49.775 37.5604 49.775H28.6229C27.0875 49.775 24.9333 49.2479 23.9479 48.2625L21.0146 45.9937C19.8916 45.1458 19.2271 43.7937 19.2271 42.3729Z",
    fill: "#D8DEF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9397 14.6208H9.57933C6.02725 14.6208 4.5835 15.9958 4.5835 19.3875V42.4417C4.5835 45.8334 6.02725 47.2084 9.57933 47.2084H11.9397C15.4918 47.2084 16.9356 45.8334 16.9356 42.4417V19.3875C16.9356 15.9958 15.4918 14.6208 11.9397 14.6208Z",
    fill: "#D8DEF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.ef445c92e8745630596162623368fe8e.svg";
export { ForwardRef as ReactComponent };